export default "__VITE_ASSET__CJ1BmVz3__"